"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvoysFromVenus = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const CardRequirements_1 = require("../CardRequirements");
const Tags_1 = require("../Tags");
const SendDelegateToArea_1 = require("../../deferredActions/SendDelegateToArea");
class EnvoysFromVenus extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.ENVOYS_FROM_VENUS,
            tags: [Tags_1.Tags.VENUS],
            cost: 1,
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.tag(Tags_1.Tags.VENUS, 3)),
            metadata: {
                cardNumber: 'P72',
                description: 'Requires 3 Venus tags. Place 2 delegates in 1 party.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.delegates(2);
                }),
            },
        });
    }
    play(player) {
        player.game.defer(new SendDelegateToArea_1.SendDelegateToArea(player, 'Select where to send 2 delegates', { count: 2, source: 'reserve' }));
        return undefined;
    }
}
exports.EnvoysFromVenus = EnvoysFromVenus;
//# sourceMappingURL=EnvoysFromVenus.js.map